import React from 'react';
import AuditLogsContainer from './AuditLogsContainer';

export const MESSAGES = {
  title: 'Logs de auditoría',
};

const COLUMNS = [
  {
    id: 'user',
    label: 'Usuario',
    field: 'user',
    minWidth: 100,
  },
  {
    id: 'action',
    label: 'Acción',
    minWidth: 100,
    hidden: {
      xsDown: true,
    },
  },
  {
    id: 'collectionName',
    label: 'Colección',
    minWidth: 120,
  },
  {
    id: 'created',
    label: 'Fecha',
    minWidth: 150,
  },
  {
    id: 'affectedEntity',
    field: 'affectedEntity',
    label: 'Detalles',
    minWidth: 150,
  },
];

export const ENTITY_PROPS = {
  entityName: 'audit logs',
  endpoint: 'audit-logs',
  path: '/home/audit',
};

const AuditLogsTable = () => {


  return <AuditLogsContainer
      allowCreateNew={false}
      enableActions={false}
      entityProps={ENTITY_PROPS}
      messages={MESSAGES}
      columns={COLUMNS}
    />;
};

export default AuditLogsTable;